import { usePageTitle } from 'hooks'
import BasePage from 'pages/base-page/base-page.page'
import { useTranslation } from 'react-i18next'
import { stringService } from 'services'

import './about.scss'

const About: React.FC = () => {
  const { t } = useTranslation()

  const titlePage = stringService.capitalizeFirstLetter(t('about_us'))
  usePageTitle(titlePage!)

  return (
    <BasePage pageClass="edisu-page-about-us">
      <div className="content">
        <h2 className="title">{titlePage}</h2>
        <span>{t('about_desc1')}</span>
        <span>{t('about_desc2')}</span>
      </div>
    </BasePage>
  )
}

export default About
